import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {
    email: '',
    emailCode: '',
    exist: false,
    formpage: '',
  },
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, actions) => {
      const { key, value } = actions.payload;
      if (Object.prototype.hasOwnProperty.call(initialState.userInfo, key)) {
        state.userInfo[key] = value;
      }
    },
    clearUserInfo: (state) => {
      state.userInfo = {
        email: '',
      };
    },
  },
});

export const { setUserInfo, clearUserInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
